/* eslint-disable global-require */
export const GuideImage = {
  '1x': require('../../../assets/guide-open-img.png'),
  '2x': require('../../../assets/guide-open-img@2x.png'),
  '3x': require('../../../assets/guide-open-img@3x.png'),
};

export const bgImage = {
  mobile: require('../../../assets/mobile-main-img.jpg'),
  desktop: require('../../../assets/Desktop-BG.jpg'),
};
/* eslint-enable */

const getBgImage = () => {
  if (typeof window !== 'undefined') {
    return window.matchMedia('(min-width: 768px)').matches
      ? `url(${bgImage.desktop})`
      : `url(${bgImage.mobile})`;
  }

  return `url(${bgImage.desktop})`;
};

export const bgStyles = {
  backgroundImage: getBgImage(),
};



// WEBPACK FOOTER //
// ./src/reactModules/pages/GeneralPlanning/components/Hero/css/assets.js